import { Typography } from '@/components/ui/typography'
import { ReadOnly } from '@/lib/casl'
import { useFormContext } from '@/lib/form-contexts'
import { locationFilters, useLocations } from '@/lib/services/locations/locations.query'
import { isSameDayDeliveryPromotionEligible } from '@/lib/services/stores/stores.utils'
import { Clock3 } from 'lucide-react'

const filters = locationFilters().get()

export default function SameDayDeliveryAnnouncementSettings({ canEditStore }) {
  const form = useFormContext()
  const { data: locations = [] } = useLocations({ filters })
  if (!isSameDayDeliveryPromotionEligible(locations)) {
    return null
  }

  return (
    <section className="border-t border-border/60 pt-8" aria-labelledby="same-day-delivery-title">
      <ReadOnly isReadOnly={!canEditStore} overrideRoute>
        <div className="flex flex-col gap-4">
          <div>
            <div className="inline-flex items-center gap-2">
              <Clock3 className="size-5" aria-hidden="true" />
              <Typography variant="h4" id="same-day-delivery-title">
                Same-Day Delivery Banner
              </Typography>
            </div>
            <Typography variant="supporting" className="mt-1 block">
              Let customers know when they can still order flowers for delivery today.
            </Typography>
          </div>

          <div className="ml-6">
            <form.AppField name="store_settings.same_day_delivery_promotion_enabled">
              {(field) => <field.SwitchInput label="Show this banner on my website" />}
            </form.AppField>
          </div>
        </div>
      </ReadOnly>
    </section>
  )
}
